import { forwardRef } from 'react';

import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

SwiperCore.use([Autoplay]);

export type Slide = {
  id: string;
  slide: React.ReactNode;
};

type CarouselProps = {
  slidesPerView?: number;
  spaceBetween?: number;
  slides: Slide[];
  callback?: () => void; // eslint-disable-line
  loop?: boolean;
  autoplay?: boolean;
};

const Carousel = forwardRef((props: CarouselProps, ref): React.ReactElement => {
  const {
    slides,
    slidesPerView = 3,
    spaceBetween = 50,
    callback = undefined,
    loop = false,
    autoplay = false,
  } = props;

  const slidesIntoComponent = slides?.map((item: Slide) => (
    <SwiperSlide key={item.id}>{item.slide}</SwiperSlide>
  ));

  return (
    <Swiper
      // @ts-ignore
      ref={ref}
      allowTouchMove={false}
      spaceBetween={spaceBetween}
      slidesPerView={slidesPerView}
      onSlideChange={() => {
        if (callback) {
          callback();
        }
      }}
      loop={loop}
      autoplay={autoplay}
      autop
    >
      {slidesIntoComponent}
    </Swiper>
  );
});

export { Carousel };
